
import { Link } from 'react-router-dom';
import NewsletterForm from '../../../components/feature/NewsletterForm';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-teal-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-teal-400 to-teal-600 rounded-lg flex items-center justify-center">
                <i className="ri-brain-line text-xl text-white"></i>
              </div>
              <span className="text-xl font-bold">Agent IA Pro</span>
            </div>
            <p className="text-sm text-gray-300 mb-4">
              La plateforme leader pour créer et déployer des agents IA intelligents qui transforment votre entreprise.
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-linkedin-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-github-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-youtube-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Produits</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/agent/customer-support" className="text-sm text-gray-300 hover:text-white transition-colors">
                  Support Client
                </Link>
              </li>
              <li>
                <Link to="/agent/sales-assistant" className="text-sm text-gray-300 hover:text-white transition-colors">
                  Assistant Commercial
                </Link>
              </li>
              <li>
                <Link to="/agent/data-analyst" className="text-sm text-gray-300 hover:text-white transition-colors">
                  Analyste de Données
                </Link>
              </li>
              <li>
                <Link to="/demo" className="text-sm text-gray-300 hover:text-white transition-colors">
                  Démo Interactive
                </Link>
              </li>
              <li>
                <a href="#pricing" className="text-sm text-gray-300 hover:text-white transition-colors">
                  Tarifs
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Ressources</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/blog" className="text-sm text-gray-300 hover:text-white transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/case-studies" className="text-sm text-gray-300 hover:text-white transition-colors">
                  Études de Cas
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-300 hover:text-white transition-colors">
                  Documentation
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-300 hover:text-white transition-colors">
                  API
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-300 hover:text-white transition-colors">
                  Centre d'Aide
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <NewsletterForm variant="footer" />
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © {currentYear} Agent IA Pro. Tous droits réservés.
            </p>
            <div className="flex flex-wrap gap-6">
              <Link to="/privacy-policy" className="text-sm text-gray-400 hover:text-white transition-colors">
                Confidentialité
              </Link>
              <Link to="/terms-of-service" className="text-sm text-gray-400 hover:text-white transition-colors">
                Conditions
              </Link>
              <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors">
                Cookies
              </a>
              <Link to="/legal-notice" className="text-sm text-gray-400 hover:text-white transition-colors">
                Mentions légales
              </Link>
              <Link to="/contact" className="text-sm text-gray-400 hover:text-white transition-colors">
                Contact
              </Link>
              <a href="https://readdy.ai/?ref=logo" className="text-sm text-gray-400 hover:text-white transition-colors">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
